/**
 * Describes a Contact Email Details object
 */
export class ContactEmailDetails {
  name: string;
  organisation: string;
  emailAddress: string;
  enquiryType: string;
  message: string;
}